import DefaultMostRead, { StandaloneMostRead } from '@/base/components/content/MostRead';
import { LabradorComponent } from '@/types/component';
import { Content } from '@/types/content';

const FeminaLabradorMostRead: LabradorComponent = ({ type, data, meta, descendants }) => {
  descendants.forEach((descendant: Content) => delete descendant?.data?.category);

  return <DefaultMostRead {...{ type, data, meta, descendants }} />;
};

export const standalone = StandaloneMostRead;

export default FeminaLabradorMostRead;
